import React, {Component} from 'react';
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../components/textbox/Input";
import Utils from "../../../../../../utils/Utils"

import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import SelectAutocomplete from "../../../../../../components/selectAutocomplete/SelectAutocomplete";

class SezioneSette extends Component {

    state = {
        sezioneSette: {
            doseB: "",
            listaDosi: [
                {tipoDoseB: "", dataDoseB: ""},
                {tipoDoseB: "", dataDoseB: ""},
                {tipoDoseB: "", dataDoseB: ""}
            ],
            corretto: []
        },
        controlloAutocomplete:{
            tipoDoseB0:true,
            tipoDoseB1:true,
            tipoDoseB2:true
        }
    }

    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.controllaDati = this.controllaDati.bind(this);
        this.createJsonBackend = this.createJsonBackend.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.sezioneSette) {
            let sezioneSette = this.state.sezioneSette
            let controlloAutocomplete=this.state.controlloAutocomplete
            let propsSezione = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.sezioneSette))
            sezioneSette.doseB = propsSezione.doseB
            if (propsSezione.listaDosi) {
                for (let i = 0; i < propsSezione.listaDosi.length; i++) {
                    sezioneSette.listaDosi[i].tipoDoseB = propsSezione.listaDosi[i].tipoDoseB ? propsSezione.listaDosi[i].tipoDoseB : ""
                    sezioneSette.listaDosi[i].dataDoseB = propsSezione.listaDosi[i].dataDoseB ? propsSezione.listaDosi[i].dataDoseB : ""
                }
                controlloAutocomplete.tipoDoseB0=sezioneSette.listaDosi[0].tipoDoseB && Utils.arrayToMap(OggettiUtili.tipoVaccino, "codice")[sezioneSette.listaDosi[0].tipoDoseB] ? true : false
                controlloAutocomplete.tipoDoseB1=sezioneSette.listaDosi[1].tipoDoseB && Utils.arrayToMap(OggettiUtili.tipoVaccino, "codice")[sezioneSette.listaDosi[1].tipoDoseB] ? true : false
                controlloAutocomplete.tipoDoseB2=sezioneSette.listaDosi[2].tipoDoseB && Utils.arrayToMap(OggettiUtili.tipoVaccino, "codice")[sezioneSette.listaDosi[2].tipoDoseB] ? true : false

            }
            this.setState({sezioneSette: sezioneSette, controlloAutocomplete: controlloAutocomplete})
        }
        this.controllaDati()
        this.props.setSezioneSette(this.state.sezioneSette, this.validate())

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati();
        if (prevState !== this.state) {
            let res = this.createJsonBackend()
            this.props.setSezioneSette(this.state.sezioneSette, this.validate(), res)
        }
    }

    validate() {

        for (let i = 0; i < this.state.sezioneSette.listaDosi.length; i++) {
            if (this.state.sezioneSette.listaDosi[i].dataDoseB) {
                let validatedataDoseB = Utils.checkDateInterval(this.state.sezioneSette.listaDosi[i].dataDoseB, "31/12/1899");
                let validatedataDoseBOdierna = Utils.checkDateInterval(this.state.sezioneSette.listaDosi[i].dataDoseB, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

                if (validatedataDoseB) {
                    return "Messages.DataDoseB"
                } else if (!validatedataDoseBOdierna) {
                    return "Messages.DataDoseBOdierna"
                }
            }
        }
        if (!this.state.sezioneSette.doseB || this.state.sezioneSette.doseB === "01" || this.state.sezioneSette.doseB === "05") {
            if (this.state.sezioneSette.listaDosi[0].tipoDoseB) {
                return "Messages.ERR_01_02_0D_AL"
            } else if (this.state.sezioneSette.listaDosi[0].dataDoseB) {
                return "Messages.ERR_01_02_0D_AM"
            }
        }

        if (!this.state.sezioneSette.doseB || (this.state.sezioneSette.doseB !== "03" && this.state.sezioneSette.doseB !== "04")) {
            if (this.state.sezioneSette.listaDosi[1].tipoDoseB) {
                return "Messages.ERR_01_02_0D_AN"
            } else if (this.state.sezioneSette.listaDosi[1].dataDoseB) {
                return "Messages.ERR_01_02_0D_AO"
            }
        }

        if (!this.state.sezioneSette.doseB || this.state.sezioneSette.doseB !== "04") {
            if (this.state.sezioneSette.listaDosi[2].tipoDoseB) {
                return "Messages.ERR_01_02_0D_AP"
            } else if (this.state.sezioneSette.listaDosi[2].dataDoseB) {
                return "Messages.ERR_01_02_0D_AQ"
            }
        }


        return ""

    }

    createJsonBackend() {
        let ObjectForBackEnd = {}
        let dati = JSON.parse(JSON.stringify(this.state.sezioneSette))
        ObjectForBackEnd["doseB"] = dati.doseB
        ObjectForBackEnd["listaDosi"] = Utils.removeEmptyValueFromObject(dati.listaDosi)
        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        return res
    }

    controllaDati() {

        let dati = this.state.sezioneSette
        dati.corretto = []

        if((dati.doseB === "02" || dati.doseB === "03" || dati.doseB === "04" ) && !dati.listaDosi[0].tipoDoseB) dati.corretto[0] = "Campo \"Se sì, 1° dose - tipo vaccino\" mancante";
        if((dati.doseB === "02" || dati.doseB === "03" || dati.doseB === "04" ) && (!dati.listaDosi[0].dataDoseB || (dati.listaDosi[0].dataDoseB !== "" && Utils.isDateInValid(Utils.transformDateForBackend(dati.listaDosi[0].dataDoseB), "-")))) dati.corretto[1] = "Campo \"Data\" mancante o errato";

        if(( dati.doseB === "03" || dati.doseB === "04" ) && !dati.listaDosi[1].tipoDoseB) dati.corretto[3] = "Campo \"Se sì, 2° dose - tipo vaccino\" mancante";
        if((dati.doseB === "03" || dati.doseB === "04" ) && (!dati.listaDosi[1].dataDoseB || (dati.listaDosi[1].dataDoseB !== "" && Utils.isDateInValid(Utils.transformDateForBackend(dati.listaDosi[1].dataDoseB), "-")))) dati.corretto[4] = "Campo \"Data\" mancante o errato";

        if((dati.doseB === "04" ) && !dati.listaDosi[2].tipoDoseB) dati.corretto[5] = "Campo \"Se sì, 3° dose - tipo vaccino\" mancante";
        if((dati.doseB === "04" ) && (!dati.listaDosi[2].dataDoseB || (dati.listaDosi[2].dataDoseB !== "" && Utils.isDateInValid(Utils.transformDateForBackend(dati.listaDosi[2].dataDoseB), "-")))) dati.corretto[6] = "Campo \"Data\" mancante o errato";

    }

    riceviValoreRadioButton(event, field) {
        let sezioneSette = this.state.sezioneSette
        sezioneSette[field] = event

        this.setState({sezioneSette: sezioneSette})
    }

    riceviValoreInput(field, event) {

        let sezioneSette = this.state.sezioneSette
        let controlloAutocomplete=this.state.controlloAutocomplete
        if (field.currentTarget) {
            if (field.currentTarget.id.includes("dataDoseB")) {
                let indice = parseInt(field.currentTarget.id.replace("dataDoseB", ""))
                sezioneSette.listaDosi[indice].dataDoseB = field.currentTarget.value
            } else {
                sezioneSette[field.currentTarget.id] = field.currentTarget.value
            }
        } else {
            if (field.includes("tipoDoseB")) {
                let indice = parseInt(field.replace("tipoDoseB", ""))
                if (!event.target.value) {
                    if(indice===0) controlloAutocomplete.tipoDoseB0 = true
                    else if (indice===1) controlloAutocomplete.tipoDoseB1=true
                    else if (indice===2) controlloAutocomplete.tipoDoseB2=true
                }
                sezioneSette.listaDosi[indice].tipoDoseB = event.target.value
            } else {
                sezioneSette[field] = event.target.value
            }
        }
        this.setState({sezioneSette: sezioneSette,controlloAutocomplete: controlloAutocomplete})
    }

    render() {

        const {t} = this.props;

        const sezioneSette = (
            <div style={{marginTop: "10px"}}>
                <div>
                    <h6>Sezione 7</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div className="row">
                        <div className="col-lg-6"><p className={styles.labelHeader} style={{marginTop: "10px"}}>
                            <b>{t("SchedaEpatite.sezione7.domandaUno")}</b></p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"dose0B"}
                                             name={"doseB"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "doseB")}
                                             checked={this.state.sezioneSette.doseB === "01"}>
                                </RadioButton>
                                <RadioButton id={"dose1B"}
    name={"doseB"} label={"Si, una dose"}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "doseB")}
    checked={this.state.sezioneSette.doseB === "02"}
    />
                                <RadioButton id={"dose2B"}
    name={"doseB"} label={"Si, due dosi"}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "doseB")}
    checked={this.state.sezioneSette.doseB === "03"}
    />
                                <RadioButton id={"dose3B"}
    name={"doseB"} label={"Si, tre dosi"}
    value={"04"}
    onClick={() => this.riceviValoreRadioButton("04", "doseB")}
    checked={this.state.sezioneSette.doseB === "04"}
    />
                                <RadioButton id={"dose4B"}
    name={"doseB"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"05"}
    onClick={() => this.riceviValoreRadioButton("05", "doseB")}
    checked={this.state.sezioneSette.doseB === "05"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione5.primaDose")}</b>
                                {(this.state.sezioneSette.doseB === "02" || this.state.sezioneSette.doseB === "03" || this.state.sezioneSette.doseB === "04") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px", height: "50px"}}>
                            {(this.state.sezioneSette.listaDosi[0].tipoDoseB && Utils.arrayToMap(OggettiUtili.tipoVaccino, "codice")[this.state.sezioneSette.listaDosi[0].tipoDoseB]) || !this.state.sezioneSette.listaDosi[0].tipoDoseB || this.state.controlloAutocomplete.tipoDoseB0 ?

                                <SelectAutocomplete
                                    id={"tipoDoseB0"}
                                    field={"tipoDoseB0"}
                                    newSelect={true}
                                    onChange={this.riceviValoreInput}
                                    value={this.state.sezioneSette.listaDosi[0].tipoDoseB}
                                    functionMap={Utils.sortByKey(OggettiUtili.tipoVaccino, "descrizione").map((oggetto) => {
                                        return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                    })}/>
                                :
                                <Input
                                    id="tipoDoseB0"
                                    onChange={this.riceviValoreInput}
                                    field={"tipoDoseB0"}
                                    value={this.state.sezioneSette.listaDosi[0].tipoDoseB}
                                    placeholder={"Tipo vaccino"}
                                >
                                </Input>
                            }

                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione5.quando")}</b>
                                {(this.state.sezioneSette.doseB === "02" || this.state.sezioneSette.doseB === "03" || this.state.sezioneSette.doseB === "04") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px"}}>

                            <Calendar
                                id="dataDoseB0"
                                field={"dataDoseB0"}
                                value={this.state.sezioneSette.listaDosi[0].dataDoseB}
                                onChange={this.riceviValoreInput}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    "Data")}
                                error={(this.state.sezioneSette.listaDosi[0].dataDoseB === "" ||
                                    this.state.sezioneSette.listaDosi[0].dataDoseB == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.sezioneSette.listaDosi[0].dataDoseB), "-")}>
                            </Calendar>
                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione5.secondaDose")}</b>
                                {(this.state.sezioneSette.doseB === "03" || this.state.sezioneSette.doseB === "04") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px", height: "50px"}}>
                            {(this.state.sezioneSette.listaDosi[1].tipoDoseB && Utils.arrayToMap(OggettiUtili.tipoVaccino, "codice")[this.state.sezioneSette.listaDosi[1].tipoDoseB]) || !this.state.sezioneSette.listaDosi[1].tipoDoseB || this.state.controlloAutocomplete.tipoDoseB1 ?

                                <SelectAutocomplete
                                    id={"tipoDoseB1"}
                                    field={"tipoDoseB1"}
                                    newSelect={true}
                                    onChange={this.riceviValoreInput}
                                    value={this.state.sezioneSette.listaDosi[1].tipoDoseB}
                                    functionMap={Utils.sortByKey(OggettiUtili.tipoVaccino, "descrizione").map((oggetto) => {
                                        return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                    })}/>
                                :
                                <Input
                                    id="tipoDoseB1"
                                    onChange={this.riceviValoreInput}
                                    field={"tipoDoseB1"}
                                    value={this.state.sezioneSette.listaDosi[1].tipoDoseB}
                                    placeholder={"Tipo vaccino"}
                                >
                                </Input>
                            }

                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione5.quando")}</b>
                                {(this.state.sezioneSette.doseB === "03" || this.state.sezioneSette.doseB === "04") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px"}}>

                            <Calendar
                                id="dataDoseB1"
                                field={"dataDoseB1"}
                                value={this.state.sezioneSette.listaDosi[1].dataDoseB}
                                onChange={this.riceviValoreInput}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    "Data")}
                                error={(this.state.sezioneSette.listaDosi[1].dataDoseB === "" ||
                                    this.state.sezioneSette.listaDosi[1].dataDoseB == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.sezioneSette.listaDosi[1].dataDoseB), "-")}>
                            </Calendar>

                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione5.terzaDose")}</b>
                                {(this.state.sezioneSette.doseB === "04") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}

                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px", height: "50px"}}>
                            {(this.state.sezioneSette.listaDosi[2].tipoDoseB && Utils.arrayToMap(OggettiUtili.tipoVaccino, "codice")[this.state.sezioneSette.listaDosi[2].tipoDoseB]) || !this.state.sezioneSette.listaDosi[2].tipoDoseB || this.state.controlloAutocomplete.tipoDoseB2 ?

                                <SelectAutocomplete
                                    id={"tipoDoseB2"}
                                    field={"tipoDoseB2"}
                                    newSelect={true}
                                    onChange={this.riceviValoreInput}
                                    value={this.state.sezioneSette.listaDosi[2].tipoDoseB}
                                    functionMap={Utils.sortByKey(OggettiUtili.tipoVaccino, "descrizione").map((oggetto) => {
                                        return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                    })}/>
                                :
                                <Input
                                    id="tipoDoseB2"
                                    onChange={this.riceviValoreInput}
                                    field={"tipoDoseB2"}
                                    value={this.state.sezioneSette.listaDosi[2].tipoDoseB}
                                    placeholder={"Tipo vaccino"}
                                >
                                </Input>
                            }

                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione5.quando")}</b>
                                {(this.state.sezioneSette.doseB === "04") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}

                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px"}}>

                            <Calendar
                                id="dataDoseB2"
                                field={"dataDoseB2"}
                                value={this.state.sezioneSette.listaDosi[2].dataDoseB}
                                onChange={this.riceviValoreInput}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    "Data")}
                                error={(this.state.sezioneSette.listaDosi[2].dataDoseB === "" ||
                                    this.state.sezioneSette.listaDosi[2].dataDoseB == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.sezioneSette.listaDosi[2].dataDoseB), "-")}>
                            </Calendar>
                        </div>

                    </div>
                </div>
            </div>
        );


        return <div>

            {sezioneSette}
        </div>
    }


}

export default withTranslation('common')(SezioneSette)
